import { clubbiStyled } from 'clubbi-ui'

export const StyledContainer = clubbiStyled('div')(({ theme }) => ({
  color: theme.palette.brandYellow[100],
  backgroundColor: theme.palette.brandYellow[20],
  width: '100%',
  gap: '8px',
  marginTop: '4px',
  display: 'flex',
  padding: '10px',
  borderRadius: '4px',
  fontSize: '10px',
  [theme.breakpoints.up('md')]: {
    fontSize: '12px',
  },
}))

export const StyledMessages = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const StyledAdditionalMessage = clubbiStyled('span')(({ theme }) => ({
  color: '#F0373B',
}))
